import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
export default class FlagshipSticky {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.ctaTriggers = document.querySelectorAll('[data-hero-trigger-stickybar]')
    this.heroAreaTrigger = document.querySelector('.hero--flagship')
    this.firstTrigger = ''
  }

  init() {
    this.el.classList.remove('js-init-hidden')
    this.handleSetTrigger()
    this.fadeInOut()
  }

  handleSetTrigger() {
    if (typeof (this.ctaTriggers) === 'undefined') {
      this.firstTrigger = this.heroAreaTrigger
    } else {
      this.firstTrigger = this.ctaTriggers[0]
    }
  }

  fadeInOut() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.firstTrigger,
        toggleActions: 'play none reverse none',
        start: 'bottom top',
      },
    })
    gsap.set(this.el, { autoAlpha: 0, y: -85 })
    tl.to(this.el, {
      autoAlpha: 1,
      duration: 0.25,
      yPercent: 0,
      y: 0,
    })
  }
}
